import { renderFn, get } from 'micromustache';
// TODO: take a look at this PR: https://github.com/Ajaxy/cast-with-schema/pull/12
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import castWithSchema from 'cast-with-schema';
export function buildInputPropsFromContext(context, config, schema) {
    // const interpolatedProps: Record<string, unknown> = { ...config.props };
    // // TODO: This needs to interpolate nested objects
    // for (const key in interpolatedProps) {
    //   // eslint-disable-next-line security/detect-object-injection
    //   const value = interpolatedProps[key];
    //   if (typeof value === 'string') {
    //     // eslint-disable-next-line security/detect-object-injection
    //     interpolatedProps[key] = renderFn(value, resolveTemplate, context);
    //   }
    // }
    var interpolatedProps = interpolateDeeply(config.props || {}, context);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
    var castedProps = castWithSchema(interpolatedProps, schema);
    return castedProps;
}
function interpolateDeeply(value, context) {
    if (value === null || value === undefined) {
        return {};
    }
    if (typeof value === 'string') {
        return renderFn(value, resolveTemplate, context);
    }
    if (typeof value === 'object' && value !== null && value !== undefined && !Array.isArray(value)) {
        var newValue = {};
        for (var key in value) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, security/detect-object-injection
            var val = value[key];
            // eslint-disable-next-line security/detect-object-injection
            newValue[key] = interpolateDeeply(val, context);
        }
        return newValue;
    }
    return value;
}
function resolveTemplate(varName, scope) {
    if (!scope) {
        throw Error('Scope is required');
    }
    var value = get(scope, varName);
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        return JSON.stringify(value);
    }
    return value;
}
//# sourceMappingURL=buildInputPropsFromContext.js.map